"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactNativeWeb = require("react-native-web");

var PLATFORMS = {
  WEB: 'web',
  IOS: 'ios',
  ANDROID: 'android'
};
var IS_WEB = _reactNativeWeb.Platform.OS === PLATFORMS.WEB;
var IS_MOBILE = !IS_WEB;
var IS_ANDROID = _reactNativeWeb.Platform.OS === PLATFORMS.ANDROID;
var IS_IOS = _reactNativeWeb.Platform.OS === PLATFORMS.IOS;
var _default = {
  IS_WEB: IS_WEB,
  IS_MOBILE: IS_MOBILE,
  IS_ANDROID: IS_ANDROID,
  IS_IOS: IS_IOS
};
exports["default"] = _default;